import { useCallback, useRef } from 'react';

import { useEditionsAnalyticsContext } from '../Upgrade/AnalyticsProvider';

export const useFeatureExposedAnalytics = () => {
	const { createAnalyticsEvent } = useEditionsAnalyticsContext();
	const sentFlagKeys = useRef<string[]>([]);

	// This ensures the experiment exposure event is only fired once per flagKey
	return useCallback(
		({
			flagKey,
			cohort,
			source,
			growthInitiative,
		}: {
			flagKey: string;
			cohort: string;
			source: string;
			growthInitiative?: string;
		}) => {
			if (sentFlagKeys.current.includes(flagKey)) {
				return;
			}

			createAnalyticsEvent({
				type: 'sendTrackEvent',
				data: {
					action: 'exposed',
					actionSubject: 'feature',
					source,
					attributes: {
						flagKey,
						cohort,
						growthInitiative,
					},
				},
			}).fire();

			sentFlagKeys.current.push(flagKey);
		},
		[createAnalyticsEvent],
	);
};
